import React from "react";

const FinanceApprovedDevices = () => {
  return (
    <>
      <style>
        {`
          @keyframes gradientMove {
            0% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0% 50%;
            }
          }

          @keyframes float {
            0%, 100% {
              transform: translateY(0px) translateX(0px);
            }
            33% {
              transform: translateY(-30px) translateX(15px);
            }
            66% {
              transform: translateY(15px) translateX(-15px);
            }
          }

          @keyframes deviceFloat {
            0%, 100% {
              transform: translateY(0px) rotateY(0deg);
            }
            50% {
              transform: translateY(-20px) rotateY(10deg);
            }
          }

          @keyframes pulse {
            0%, 100% {
              opacity: 0.6;
              transform: scale(1);
            }
            50% {
              opacity: 1;
              transform: scale(1.05);
            }
          }

          @keyframes shimmer {
            0% {
              background-position: -1000px 0;
            }
            100% {
              background-position: 1000px 0;
            }
          }

          .project-page {
            position: relative;
            background: linear-gradient(-45deg, #000000, #0a0a0a, #1a0a1a, #0a1a2a);
            background-size: 400% 400%;
            animation: gradientMove 15s ease infinite;
            min-height: 100vh;
            padding: 90px 20px;
            color: #fff;
            font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
            overflow: hidden;
          }

          .project-page::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: 
              radial-gradient(circle at 20% 30%, rgba(96, 165, 250, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 80% 70%, rgba(236, 72, 153, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 40% 80%, rgba(167, 139, 250, 0.08) 0%, transparent 50%);
            animation: float 20s ease-in-out infinite;
            pointer-events: none;
          }

          .project-page::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: 
              repeating-linear-gradient(
                0deg,
                transparent,
                transparent 2px,
                rgba(255, 255, 255, 0.03) 2px,
                rgba(255, 255, 255, 0.03) 4px
              ),
              repeating-linear-gradient(
                90deg,
                transparent,
                transparent 2px,
                rgba(255, 255, 255, 0.03) 2px,
                rgba(255, 255, 255, 0.03) 4px
              );
            pointer-events: none;
          }

          .project-container {
            max-width: 1200px;
            margin: auto;
            position: relative;
            z-index: 1;
          }

          .project-badge {
            display: inline-block;
            background: linear-gradient(135deg, #10b981, #60a5fa);
            padding: 8px 24px;
            border-radius: 30px;
            font-size: 14px;
            font-weight: 600;
            margin-bottom: 30px;
            text-transform: uppercase;
            letter-spacing: 1.5px;
          }

          .project-title {
            font-size: 52px;
            font-weight: 700;
            margin-bottom: 40px;
            letter-spacing: 1px;
            background: linear-gradient(135deg, #10b981, #60a5fa, #ec4899, #10b981);
            background-size: 300% 300%;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            animation: gradientMove 8s ease infinite;
          }

          .hero-section {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 60px;
            align-items: center;
            margin-bottom: 100px;
          }

          .hero-content {
            padding-right: 20px;
          }

          .hero-text {
            font-size: 18px;
            line-height: 1.9;
            color: #d1d5db;
            text-align: justify;
            margin-bottom: 20px;
          }

          .devices-animation-container {
            position: relative;
            height: 500px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .devices-visual {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 30px;
          }

          .device {
            position: relative;
            background: linear-gradient(145deg, #1a1a1a, #2a2a2a);
            border-radius: 20px;
            box-shadow: 
              0 20px 60px rgba(0, 0, 0, 0.8),
              0 0 40px rgba(96, 165, 250, 0.3);
            animation: deviceFloat 6s ease-in-out infinite;
            overflow: hidden;
          }

          .device::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              90deg,
              transparent,
              rgba(255, 255, 255, 0.1),
              transparent
            );
            animation: shimmer 3s infinite;
          }

          .tablet {
            width: 200px;
            height: 280px;
            border: 6px solid;
            border-image: linear-gradient(135deg, #10b981, #60a5fa) 1;
            animation-delay: 0s;
          }

          .phone {
            width: 140px;
            height: 280px;
            border: 6px solid;
            border-image: linear-gradient(135deg, #60a5fa, #ec4899) 1;
            animation-delay: 1s;
          }

          .device-screen {
            width: 100%;
            height: 100%;
            background: linear-gradient(180deg, #0a0a0a, #1a1a1a);
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            gap: 15px;
            padding: 20px;
          }

          .device-icon {
            font-size: 50px;
          }

          .device-label {
            font-size: 13px;
            color: #10b981;
            font-weight: 600;
            letter-spacing: 2px;
            text-transform: uppercase;
          }

          .check-badge {
            width: 50px;
            height: 50px;
            background: linear-gradient(135deg, #10b981, #059669);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            animation: pulse 2s ease-in-out infinite;
          }

          .glow-ring {
            position: absolute;
            border-radius: 50%;
            border: 2px solid rgba(16, 185, 129, 0.2);
            animation: pulse 4s ease-in-out infinite;
          }

          .ring-1 {
            width: 400px;
            height: 400px;
          }

          .ring-2 {
            width: 500px;
            height: 500px;
            border-color: rgba(96, 165, 250, 0.15);
            animation-delay: 1s;
          }

          .description-section {
            background: linear-gradient(145deg, #0d0d0d, #1a1a1a);
            padding: 60px;
            border-radius: 20px;
            margin-bottom: 40px;
            box-shadow: 0 25px 50px rgba(0, 0, 0, 0.7);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .description-section:hover {
            transform: translateY(-8px);
            box-shadow: 0 30px 60px rgba(0, 0, 0, 0.9);
          }

          .section-title {
            font-size: 32px;
            font-weight: 600;
            margin-bottom: 25px;
            background: linear-gradient(135deg, #10b981, #60a5fa);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .section-text {
            font-size: 17px;
            line-height: 1.9;
            color: #d1d5db;
            text-align: justify;
            margin-bottom: 20px;
          }

          .highlight-box {
            background: linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(96, 165, 250, 0.1));
            border-left: 4px solid #10b981;
            padding: 25px;
            border-radius: 10px;
            margin: 30px 0;
          }

          .highlight-text {
            font-size: 17px;
            line-height: 1.9;
            color: #d1d5db;
            text-align: justify;
            font-style: italic;
          }

          @media (max-width: 968px) {
            .hero-section {
              grid-template-columns: 1fr;
              gap: 40px;
            }

            .project-title {
              font-size: 38px;
            }

            .devices-animation-container {
              height: 400px;
            }

            .description-section {
              padding: 40px;
            }

            .devices-visual {
              gap: 20px;
            }

            .tablet {
              width: 150px;
              height: 220px;
            }

            .phone {
              width: 110px;
              height: 220px;
            }
          }
        `}
      </style>

      <section className="project-page">
        <div className="project-container">
          <div className="project-badge">Upcoming Project</div>
          <h1 className="project-title">Finance Approved Tablet & Phone</h1>

          {/* Hero Section */}
          <div className="hero-section">
            <div className="hero-content">
              <p className="hero-text">
                Zyntro Software Solutions is excited to announce our groundbreaking Finance Approved Tablet & Phone project, a comprehensive solution designed to revolutionize how customers access premium mobile devices through flexible financing options. This innovative platform bridges the gap between cutting-edge technology and affordability, enabling individuals and businesses to acquire the latest tablets and smartphones without the burden of upfront costs.
              </p>
              <p className="hero-text">
                Our finance-approved device program offers a seamless application process, instant approval decisions, and competitive financing terms tailored to meet diverse customer needs. Whether you're a student seeking educational tools, a professional requiring business devices, or an enterprise looking to equip your workforce, our solution provides accessible pathways to premium technology with transparent terms and customer-centric policies.
              </p>
            </div>

            <div className="devices-animation-container">
              <div className="glow-ring ring-1"></div>
              <div className="glow-ring ring-2"></div>
              <div className="devices-visual">
                <div className="device tablet">
                  <div className="device-screen">
                    <div className="device-icon">📱</div>
                    <div className="check-badge">✓</div>
                    <div className="device-label">Tablet</div>
                  </div>
                </div>
                <div className="device phone">
                  <div className="device-screen">
                    <div className="device-icon">📱</div>
                    <div className="check-badge">✓</div>
                    <div className="device-label">Phone</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Description Section 1 */}
          <div className="description-section">
            <h2 className="section-title">Flexible Financing Solutions</h2>
            <p className="section-text">
              At the heart of our Finance Approved Tablet & Phone project lies a sophisticated financing platform that democratizes access to premium mobile technology. Understanding that the high cost of modern devices can be a significant barrier for many customers, we've developed a comprehensive financing ecosystem that offers multiple payment plans, customizable terms, and competitive interest rates. Our platform leverages advanced credit assessment algorithms to provide instant approval decisions, eliminating the lengthy waiting periods traditionally associated with device financing.
            </p>
            <p className="section-text">
              The application process has been streamlined to ensure maximum convenience and minimal friction. Customers can apply online through our intuitive web portal or mobile application, submitting required documentation digitally and receiving approval decisions within minutes. Our system evaluates creditworthiness using a holistic approach that considers various financial indicators beyond traditional credit scores, making our financing accessible to a broader demographic including young professionals, students, and individuals building their credit history.
            </p>
            <div className="highlight-box">
              <p className="highlight-text">
                "We believe that financial circumstances should never prevent individuals from accessing the technology they need to succeed in today's digital world. Our financing solutions are designed with flexibility and fairness at their core, ensuring that premium devices are within reach for everyone."
              </p>
            </div>
            <p className="section-text">
              Our financing plans range from short-term options for those who prefer to own their devices quickly, to extended payment periods that minimize monthly obligations. Each plan comes with transparent terms, no hidden fees, and the flexibility to prepay without penalties. Additionally, we offer trade-in programs that allow customers to upgrade to newer devices by applying the value of their current device toward a new financing agreement, creating a sustainable upgrade cycle that keeps customers at the forefront of technology.
            </p>
          </div>

          {/* Description Section 2 */}
          <div className="description-section">
            <h2 className="section-title">Enterprise Solutions & Customer Protection</h2>
            <p className="section-text">
              Beyond individual consumers, our Finance Approved Tablet & Phone project offers specialized enterprise solutions designed for businesses seeking to equip their teams with modern mobile devices while managing cash flow effectively. Corporate clients benefit from bulk financing options, centralized billing, and dedicated account management. Our enterprise platform integrates seamlessly with existing procurement and asset management systems, allowing IT departments to track device deployments, manage financing agreements, and monitor payment schedules through a unified dashboard.
            </p>
            <p className="section-text">
              For businesses, we offer flexible corporate financing structures including operating leases, capital leases, and equipment financing agreements. These options provide tax advantages and balance sheet optimization while ensuring that organizations can deploy the latest technology without depleting capital reserves. Our corporate program also includes device lifecycle management services, helping businesses maximize their technology investments through planned refresh cycles, buyback programs, and sustainable disposal of outdated equipment.
            </p>
            <p className="section-text">
              Customer protection is paramount in our financing model. Every financed device comes with comprehensive insurance options covering accidental damage, theft, and mechanical failures. We've partnered with leading insurance providers to offer affordable protection plans that can be bundled into monthly payments, giving customers peace of mind throughout their ownership period. Our customer support team is available around the clock to assist with account management, payment scheduling, and any issues that may arise during the financing term.
            </p>
            <p className="section-text">
              The platform also incorporates robust security measures to protect customer financial data and prevent fraud. All transactions are encrypted using bank-grade security protocols, and our systems undergo regular security audits to maintain the highest standards of data protection. We comply with all relevant financial regulations and consumer protection laws, ensuring that our customers can trust us with their sensitive information. As Zyntro Software Solutions continues to innovate in the fintech space, our Finance Approved Tablet & Phone project represents our commitment to making technology accessible, affordable, and secure for everyone.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default FinanceApprovedDevices;